import { useMutation } from 'react-query';
import queryClient from "../../../service/reactQuery/queryClient";
import { useFetchPlansAll } from "../../Plans/Service/query";
import { useFetchInvitesAll } from "../Service/query";
import { CreateInvitesRequest, DeleteInviteRequest } from "../Service/request";

// import { EditUserRequest, SignUpRequest } from "../Services/request";


const InvitesState = () => {

    const { data: invites, isLoading } = useFetchInvitesAll()

    const {data: plans} = useFetchPlansAll()


    const DeleteInviteMutation = useMutation(
        (id) => DeleteInviteRequest(id),
        {
            onMutate: () => {
            },
            onError: (error) => {

            },
            onSuccess: (result, veriables, context) => {
                queryClient.refetchQueries("UseInvitesAll")
            },
        }
    );

    const CreateInvitesMutation = useMutation(({data, close}) => CreateInvitesRequest(data), {
        onMutate: () => {
        },
        onError: (error) => {
        },
        onSuccess: (result, variables, context) => {
            queryClient.refetchQueries("UseInvitesAll")
            variables.close()
        },
    });

    const CreateInvites = (body, close) => {
        CreateInvitesMutation.mutate({data: body, close: close})
    }

 

    const DeleteInvites = (id) => {
        console.log(id)
        DeleteInviteMutation.mutate(id)
    }

    return {
        invites, isLoading, CreateInvites, DeleteInvites, plans
    }
}

export default InvitesState